import { RedirectReponse } from '../interfaces/RedirectResponse';
import { parseAndAppendQueryParameters } from './parseAndAppendQueryParameters';

export const bindLogoutElements = (redirects: Promise<RedirectReponse>) => {
  return ($el: HTMLAnchorElement) => {
    const href = $el.href;
    $el.removeAttribute('href');
    $el.addEventListener('click', async () => {
      const logout = (await redirects).logout;
      window.location.href = parseAndAppendQueryParameters(logout, href);
    });
  };
};
